// state.js
import { atom } from "recoil";

export const isLoadingState = atom({
  key: "isLoading",
  default: false,
});
